export default __webpack_public_path__ + "static/media/Bizagi.72d79d6f.svg";